import { EventEmitter as Emitter } from 'events'

const EventEmitter = new Emitter()

export const emitEvent = (name: string) => {
  const event = new CustomEvent(`flomni:${name}`)
  window.dispatchEvent(event)
}

export const globalEmit = (message: object): void => {
  window.postMessage(JSON.stringify(message), '*')
}

export default EventEmitter
